document.addEventListener('DOMContentLoaded', function () {
	const carousels = document.querySelectorAll('.logo-carousel');

	// Freemius Pro check
	const isPro = window.wlcProData?.isPro || false;


	carousels.forEach((carousel) => {
		const track = carousel.querySelector('.logo-carousel__track');
		const template = carousel.classList.contains('logo-carousel--luxury') ? 'luxury' :
			carousel.classList.contains('logo-carousel--modern') ? 'modern' :
				carousel.classList.contains('logo-carousel--minimal') ? 'minimal' :
					carousel.classList.contains('logo-carousel--premium') ? 'premium' :
						'free';

		// animation duration from data attribute
		const duration = carousel.getAttribute('data-animation-duration') || 30;
		track.style.setProperty('--animation-duration', `${duration}s`);

		// If user is Free and template is Pro, apply overlay + blur
		if (!isPro && (template === 'luxury' || template === 'minimal' || template === 'premium' || template === 'modern')) {

			// add a class to style
			carousel.classList.add('logo-carousel--pro-locked');

			// create Pro label overlay
			const overlay = document.createElement('div');
			overlay.className = 'logo-carousel__pro-overlay';
			overlay.innerText = 'Pro Theme';

			// insert overlay on top of carousel
			carousel.style.position = 'relative';
			carousel.appendChild(overlay);
			// click on overlay -> go to upgrade link
			overlay.addEventListener('click', function () {
				window.open(upgradeLink, '_blank');
			});

		}
	});
});